/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TomoQuestionnaire } from '../../models/tomo-questionnaire';

export interface PutTomoquestionnaireId$Json$Params {

/**
 * questionnaire ID
 */
  id: string;
  'api-version'?: string;
  
    /**
     * questionnaire object
     */
    body?: TomoQuestionnaire
}

export function putTomoquestionnaireId$Json(http: HttpClient, rootUrl: string, params: PutTomoquestionnaireId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
  const rb = new RequestBuilder(rootUrl, putTomoquestionnaireId$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TomoQuestionnaire>;
    })
  );
}

putTomoquestionnaireId$Json.PATH = '/tomoQuestionnaire/{id}';
